module.exports = __webpack_public_path__ + "img/chevron-right-white.a2bf3b9a.svg";